import { cloudChiprApi } from "../../../../services/cloudchipr.api";

export const getV2UsersMeSchedulesSelector =
  cloudChiprApi.endpoints.getV2UsersMeSchedules.select({});
